import {JWTTokenParamName} from "./shared.gen";

export class SSEConnection {
    public evtSource: EventSource | null = null;
    private readonly baseSSEUrl: string;
    private readonly toConsole: boolean;
    private readonly tokenEndpoint: string;

    constructor(sseURL: string, tokenEndpoint: string, toConsole: boolean = false) {
        this.toConsole = toConsole;
        this.baseSSEUrl = sseURL;
        this.tokenEndpoint = tokenEndpoint;
    }

    public async connect() {
        const token = await this.fetchJWT();
        if (!token) {
            console.error("[SSE] Failed to obtain JWT.");
            return;
        }

        const urlWithToken = `${this.baseSSEUrl}?${JWTTokenParamName}=${encodeURIComponent(token)}`;
        this.evtSource = new EventSource(urlWithToken, { withCredentials: true });
        this.registerForEvents();
    }

    private async fetchJWT(): Promise<string | null> {
        try {
            const response = await fetch(this.tokenEndpoint, {
                method: "GET",
                credentials: "include"
            });

            if (!response.ok) {
                throw new Error("Token fetch failed");
            }

            const data = await response.json();
            return data.token;
        } catch (error) {
            console.error("[SSE] Error fetching JWT:", error);
            return null;
        }
    }

    private registerForEvents() {
        if (!this.evtSource) {
            return;
        }

        this.evtSource.addEventListener("close", (event) => {
            if (this.toConsole) {
                console.log("[SSE] server closed the connection:", event.data);
            }

            this.evtSource?.close();
        });

        if (!this.toConsole) {
            return;
        }

        console.log("[SSE] connected");

        this.evtSource.onmessage = function (event) {
            console.log("[SSE] Received message:", event.data);
        };

        this.evtSource.onerror = (err) => {
            console.error("[SSE] Error triggered", err);
            console.log("readyState:", this.evtSource?.readyState);

            if (this.evtSource?.readyState === EventSource.CLOSED) {
                console.warn("[SSE] Connection was closed.");
            } else if (this.evtSource?.readyState === EventSource.CONNECTING) {
                console.warn("[SSE] Connection is reconnecting...");
            } else {
                console.warn("[SSE] Unknown state");
            }
        };
    }
}